import {useQuery} from "@1f/react-sdk";
import sharedDatasInstance from "../sharedDatas";
import { query_sos_byFascicolo, query_sos_byTenant_count } from "../query/sosQueries";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { createSosModel } from "../helpers/modelHelpers";

export const SosApi = () => {
    const tenantId = sharedDatasInstance.getPropertyByName("tenantId");
    const aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
    const errorApiHelpers = apiErrorHelper();
    const apiSOSByTenantCount = useQuery(
        query_sos_byTenant_count,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiSOSByFascicolo = useQuery(
        query_sos_byFascicolo,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" },
    );

    const GetSOSByFascicolo = async (fascicoloId) => {
        try {
            let sos = []
            let sosResponse = await apiSOSByFascicolo.fetch({ fascicoloId: fascicoloId });
            if(sosResponse && sosResponse.data) {
                sosResponse.data.data.sos.map((sosItem) => {sos.push(createSosModel(sosItem))});                
            }
            return sos;
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error)
            throw new Error(errorMessage || 'Errore durante il caricamento delle SOS')
        }
    }

    const countSOSByTenant = async () => {
        try {
            const countSOSResponse = await apiSOSByTenantCount.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                //userId: loggedUserId,
            });
            if(countSOSResponse && countSOSResponse.data) {
                return countSOSResponse.data.data.sos_aggregate.aggregate.count;                
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || `Errore durante il recupero del conteggio SOS`);
        }
    }

    return {
        GetSOSByFascicolo,
        countSOSByTenant
    }
}